import { services } from '../../data/services';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import WaterIcon from '@mui/icons-material/Water';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import ConstructionIcon from '@mui/icons-material/Construction';
import EngineeringIcon from '@mui/icons-material/Engineering';
import './Services.css'

const Services = () => {
  const getIcon = (iconKey: string) => {
    switch (iconKey) {
      case 'precision_manufacturing':
        return <PrecisionManufacturingIcon />;
      case 'water':
        return <WaterIcon />;
      case 'directions_boat':
        return <DirectionsBoatIcon />;
      case 'construction':
        return <ConstructionIcon />;
      case 'engineering':
        return <EngineeringIcon />;
      default:
        return <EngineeringIcon />;
    }
  };

  return (
    <section className="home-services">
      <h2>Þjónusta</h2>
      <p className="home-services-subtitle">
        Við bjóðum upp á fjölbreytta þjónustu fyrir sjávarútveg og iðnað
      </p>
      <div className="home-services-grid">
        {services.map((service) => (
          <div key={service.id} className="home-service-card">
            <div className="home-service-content">
              <h3>{service.title}</h3>
              <p>{service.shortDescription}</p>
            </div>
            {getIcon(service.icon)}
          </div>
        ))}
      </div>
    </section>
  )
}

export default Services
